import type { FC } from 'react';

import { IconName } from '@catalyze/ui';

import { ContactContainer } from '../ContactContainer';
import { ContactIcon } from '../ContactIcon';
import { IconButton } from '../ContactPhones/styled';
import { ContactSubtitle } from '../ContactSubtitle';
import { ContactTitle } from '../ContactTitle';

interface IContactLine {
    contactDetail: string;
    contactUsed: string;
    onClick: () => void;
}

export const ContactEmails: FC<IContactLine> = ({
    contactDetail,
    contactUsed,
    onClick,
}) => (
    <ContactContainer>
        <IconButton type="button" onClick={onClick}>
            <ContactIcon
                icon={IconName.EMAIL}
                contacted={contactUsed.length > 0}
            />
        </IconButton>
        <div>
            <ContactTitle>{contactDetail}</ContactTitle>
            <ContactSubtitle>{contactUsed}</ContactSubtitle>
        </div>
    </ContactContainer>
);
